import { render, staticRenderFns } from "./ExcelButton.vue?vue&type=template&id=40872784&"
import script from "./ExcelButton.vue?vue&type=script&lang=js&"
export * from "./ExcelButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports